export default __webpack_public_path__ + "static/media/phishing.8cbc352f.png";